import type { ReactNode } from 'react';

/**
 * A surface the carcass slice registers so navigation is real before its screen exists.
 * Later slices replace these with the working surface in their own directory.
 */
export function Placeholder({ eyebrow, title, note }: { eyebrow: string; title: string; note: string }): ReactNode {
  return (
    <section className="page">
      <p className="eyebrow">{eyebrow}</p>
      <h1>{title}</h1>
      <p className="note">{note}</p>
    </section>
  );
}
